import styled from 'styled-components';

const ZoomOverlay = () => {
  return (
    <StyledZoomOverlay>
      <label>Use Control + Scroll to Zoom</label>
    </StyledZoomOverlay>
  );
};

export default ZoomOverlay;

const StyledZoomOverlay = styled.div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  z-index: 50;
  background-color: rgba(0, 0, 0, 0.4);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  label {
    font-weight: 600;
    font-size: 1.5rem;
    color: ${({ theme }) => theme.colors.bgColor};
  }
`;
